import { useQuery } from '@tanstack/react-query';
import { GitLabApi } from 'osep-generator-service-client-v1';
import { GITLAB_GROUPS_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useGitLabGroups(enabled = true) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [GITLAB_GROUPS_KEY],
    enabled: enabled,
    queryFn: async () => {
      const config = await getApiConfig();
      const api = new GitLabApi(config, undefined, axiosInstance);

      const result = (await api.getGroups()).data;

      return result;
    },
  });
}

export default useGitLabGroups;
